import { createSelector } from 'reselect'
import * as storesSelectors from 'services/Stores/selectors'
import {
  getRequestError,
  requestIsGetStoreDetailSelector,
} from 'services/Request/selectors'
import { DETAILS_REQUESTED } from 'services/Stores/actionTypes'
import { isUnavailableError } from './errorUtils'

export const selector = createSelector(
  [
    storesSelectors.entities,
    getRequestError(DETAILS_REQUESTED),
    requestIsGetStoreDetailSelector,
  ],
  (storeEntities, error, isRequestingStoreDetail) => ({
    storeEntities,
    hasUnavailableError: error && isUnavailableError(error),
    isRequestingStoreDetail,
  }),
)
